import React from "react";
import {cx} from "../../lib/ClassSet";
import Conditional from "../../components/Conditional";
import {List} from "immutable";
import "./PromoCodeItem.css";
import StatusTag from "../../components/StatusTag";

function formatPercentage(val) {
  return Math.round(val * 100);
}

const PromoCodeItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "promo-code-list-item": true,
    "u-selected": props.selected,
    "u-inactive": List(["expired", "depleted"]).includes(data.get("status")),
  });

  const limit = data.get("limit");
  const useCount = data.get("useCount") + (limit ? " of " + limit : "");

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-code">{data.get("code")}</td>
      <td className="field f-type">{data.get("type")}</td>
      <td className="field f-description">{data.get("description")}</td>
      <td className="field f-percentage">{formatPercentage(data.get("percentage"))}%</td>
      <RestrictionTags resType={data.get("restrictionType")} subsOnly={data.get("subscriptionsOnly")} tagRules={data.get("tagRules")} />
      <td className="field f-number">{useCount}</td>
      <td className="field f-expiryDate">{data.get("expiryDate")}</td>
      <td className="field f-status">{data.get("status")}</td>
    </tr>
  )
}

function RestrictionTags({resType, subsOnly, tagRules}) {
  return (
    <td className="field f-restriction">
      <Conditional show={resType === "customer"}>
        <StatusTag color={StatusTag.COLORS.RED} title="Customer restriction" noMargin>Customer</StatusTag>
      </Conditional>
      <Conditional show={resType === "account"}>
        <StatusTag color={StatusTag.COLORS.RED} title="Account restriction" noMargin>Account</StatusTag>
      </Conditional>
      <Conditional show={resType === "shop"}>
        <StatusTag color={StatusTag.COLORS.RED} title="Shop restriction" noMargin>Shop</StatusTag>
      </Conditional>
      <Conditional show={subsOnly === true}>
        <StatusTag color={StatusTag.COLORS.GREEN} title="Subscriptions only" noMargin>Subs</StatusTag>
      </Conditional>
      <Conditional show={tagRules !== ""}>
        <StatusTag color={StatusTag.COLORS.BLUE} title="Tag rules" noMargin>Tags</StatusTag>
      </Conditional>
    </td>
  )
}

export default PromoCodeItem;